<!--
 * @Description: 底部公司信息
 * @Author: cooky
 * @Date: 2020-06-19 14:50:27
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-12 16:40:38
-->
<template>
  <div class="bottom-info">
    <template v-if="$store.state.isPc">
      <div class="bottom-info-body">
        <div class="bottom-info-item">
          <div class="img img-coorlogo"></div>
        </div>
        <div class="bottom-info-item bottom-info--center">
          <div>
            <span @click="handleShowDialog('fwtk')" class="btn-text">【{{ $t("term_of_service") }}】</span>
            <span @click="handleShowDialog('yszc')" class="btn-text">【{{ $t("privacy_policy") }}】</span>
          </div>
          <div>Copyright © 2021 Clicktouch Technology. All rights reserved.</div>
        </div>
        <div class="bottom-info-item bottom-info--right">
          <div class="img img-grade"></div>
          <ul>
            <li>本游戏内容未涉及非普遍级之情节，依游戏软体分级管理办法分类为普遍级。</li>
            <li>本游戏为免费游戏，但游戏内另提供购买虚拟游戏币、物品等付费服务，请依个人兴趣及能力进行适度消费。</li>
            <li>请注意游戏时间，避免沉迷，长时间进行游戏，容易影响作息，宜适度休息及运动。</li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="bottom-info--top">
        <div class="bottom-info-item">
          <div class="img img-coorlogo"></div>
        </div>
        <div class="bottom-info-item">
          <div class="img img-grade"></div>
        </div>
      </div>
      <div class="bottom-info-copyright">逍遙遊國際有限公司</div>
    </template>
  </div>
</template>
<script>
// import {getText} from '@/api/index'
import { mapState } from 'vuex'
export default {
  name: 'BottomInfo',
  data () {
    return {
      serviceContent: {
        fwtk: '',
        yszc: ''
      }, // 服务条款
      type: 'fwtk'
    }
  },
  computed: {
    ...mapState([
      'isPc'
    ])
  },
  methods: {
    // 服务条款
    handleShowDialog (key) {
      // if (!this.serviceContent[key]) {
      //   this.getTextInfo(key)
      // }
      // this.type = key
      // this.$refs.dialog.open()
    },
    // 获取服务条款和注意事项
    async getTextInfo (type) {
      // const {state, data} = await getText(type)
      // if (state === 0 && data[0]) {
      //   this.serviceContent[type] = data[0].content
      // }
    }
  }
}
</script>
<style lang="less" scoped>
.bottom-info {
      background: #221f1e;
      width: 100%;
      height: 134px;
      font-size: 16px;
      // padding: 46px 0;
      // box-sizing: border-box;
      color: #fff;
      &-item {
        float: left;
        position: relative;
        text-align: left;
        box-sizing: border-box;
        &:not(:last-child)::after {
          content: '';
          position: absolute;
          width: 1px;
          height: 71px;
          right: 0;
          top: -8px;
          background-color: rgba(112, 106, 115, .4);
        }
        ul {
          display: inline-block;
          list-style: square;
          width: calc(100% - 126px);
          padding-left: 30px;
        }
      }
      &-body {
        display: flex;
        justify-content: center;
        padding: 20px 0;
        box-sizing: border-box;
        align-items: center;
        height: 100%;
      }
      &--center {
        width: 452px;
        // padding: 35px 0 0 23px;
        line-height: 1.5;
        padding-left: 16px;
      }
      &--right {
        display: flex;
        align-items: center;
        padding-left: 20px;
        max-width: 800px;
        &::after{
          display: none;
        }
      }
}
 .img {
    display: inline-block;
    background-repeat: no-repeat;
    background-size: contain;
    &-coorlogo {
      width: 286px;
      height: 51px;
      background-image: url(../../static/assets/ui/pc/coor-logo.png);
      margin-right: 10px;
    }
    &-grade {
      width: 72px;
      height: 71px;
      background-image: url(../../static/assets/ui/pc/grade.jpg);
      // vertical-align: top;
    }
  }
</style>
